/**
 * O backend guarda as métricas de campanha como uma partição: cada destinatário
 * conta em exatamente um estado (o mais avançado que alcançou). Ou seja, quem foi
 * lido NÃO aparece em `delivered`, e quem foi entregue NÃO aparece em `sent`.
 *
 * Isso confunde na leitura, porque o card parece um funil. Este helper converte a
 * partição em funil acumulado, que é como as pessoas esperam ler os números:
 *
 *   enviadas  = entregou ou não, mas a Meta aceitou  (sent + delivered + read)
 *   entregues = chegou no aparelho                   (delivered + read)
 *   lidas     = recibo de leitura                    (read)
 *
 * `unconfirmed` é o estado bruto `sent`: a Meta aceitou o envio e devolveu o wamid,
 * mas o callback de entrega nunca chegou. Fica de fora do funil porque não é um
 * estágio — é o resto de "enviadas" que nunca confirmou.
 */
export function buildCampaignFunnel(rawMetrics = {}) {
  const value = key => rawMetrics[key] || 0;

  const read = value('read');
  const delivered = value('delivered');
  const unconfirmed = value('sent');

  return {
    queued: value('queued'),
    sending: value('sending'),
    sent: unconfirmed + delivered + read,
    delivered: delivered + read,
    read,
    unconfirmed,
    failed: value('failed'),
    skipped: value('skipped'),
    cancelled: value('cancelled'),
    total: value('total'),
  };
}

/**
 * Ordem e visibilidade dos números exibidos. `queued`, `sending`, `sent`,
 * `delivered`, `read` e `failed` aparecem sempre (mesmo zerados) para dar
 * uma leitura estável; o resto só aparece quando há algo a mostrar.
 */
export const CAMPAIGN_FUNNEL_KEYS = [
  'queued',
  'sending',
  'sent',
  'delivered',
  'read',
  'unconfirmed',
  'failed',
  'skipped',
  'cancelled',
];

export const ALWAYS_VISIBLE_FUNNEL_KEYS = [
  'queued',
  'sending',
  'sent',
  'delivered',
  'read',
  'failed',
];
